import React from 'react';

import {
  Box,
  Container,
  Grid
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

import {
  FaqExpansionPanel,
  FaqExpansionPanelSummary,
  FaqExpansionPanelDetails,
  FaqMainTitle,
  QuestionTitle,
  AnswerParagraph,
} from './FaqsStyle';

import { commonStyles } from '../../styles';
import { FAQS } from './faqs_text';

const styles = theme => ({
  container: {
    ...commonStyles(theme).container,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
});

const Faqs = (props) => {
  const {classes, customClass} = props;
  const [expanded, setExpanded] = React.useState('panel0');
  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Box className={customClass} bgcolor="white" py={8}>
      <Container className={classes.container}>
        <Grid item xs={12}>
          <FaqMainTitle variant="h4" component="h2" id="frequently_asked_questions">
            Frequently Asked Questions
          </FaqMainTitle>
          <Grid item xs={11}>
            { FAQS.filter((faq) => !faq.hide).map((faq, index) =>
              <FaqExpansionPanel key={faq.q} square expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}>
                <FaqExpansionPanelSummary aria-controls={`panel${index}-content`} id={`panel${index}-header`}>
                  <QuestionTitle variant="h6" component="h3">
                    {faq.q}
                  </QuestionTitle>
                </FaqExpansionPanelSummary>
                <FaqExpansionPanelDetails>
                  <AnswerParagraph variant="body1" component="span">
                    {faq.a()}
                  </AnswerParagraph>
                </FaqExpansionPanelDetails>
              </FaqExpansionPanel>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default withStyles(styles)(Faqs);
